import { useTranslation } from "react-i18next";

const GetStartedFooter = () => {
  const { t } = useTranslation();

  return (
    <footer className="w-full bg-white px-4 sm:px-6 lg:px-8 py-6 border-t border-[#0000001A]">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-[#5A5A59]">
          <span className="text-sm">
            {t("getStarted.footerSecurityText")}
          </span>
        </div>
        <div className="flex items-center gap-4 text-sm">
          <a
            href="/#"
            className="text-[#007B83] hover:opacity-80 transition-colors"
          >
            {t("getStarted.privacyPolicy")}
          </a>
          <span className="text-[#5A5A59]">•</span>
          <a
            href="/#"
            className="text-[#007B83] hover:opacity-80 transition-colors"
          >
            {t("getStarted.termsConditions")}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default GetStartedFooter;

